import { render, staticRenderFns } from "./new_paper_order.pug?vue&type=template&id=317e0fe0&lang=pug&"
import script from "./new_paper_order.ts?vue&type=script&lang=ts&"
export * from "./new_paper_order.ts?vue&type=script&lang=ts&"
import style0 from "./new_paper_order.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports